/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmMinutelyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateZerogValidator(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/minutely/zerog/validator/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateZerogValidator1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/minutely/zerog/validator/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageSubmissionStatus(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/minutely/storage/submission/status/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageSubmissionStatus1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/minutely/storage/submission/status/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHumanityTestnetBatchProcessingStatus(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/minutely/humanity/batch/processing/status',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHumanityTestnetBatchProcessingStatus1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/minutely/humanity/batch/processing/status',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHumanityTestnetL1Status(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/minutely/humanity/batch/l1block/status',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHumanityTestnetL1Status1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/minutely/humanity/batch/l1block/status',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTopSpender({
        periodType = 'H24',
    }: {
        periodType?: 'H24' | 'D7',
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/minutely/gas/spender/update',
            query: {
                'periodType': periodType,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTopSpender1({
        periodType = 'H24',
    }: {
        periodType?: 'H24' | 'D7',
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/minutely/gas/spender/update',
            query: {
                'periodType': periodType,
            },
        });
    }

}
